module.exports = "<wor-table\n  [(data)]=\"terminals\"\n  [settings]=\"tableSettings\">\n</wor-table>\n";